<app-page-header
    title="Editar flujo BPM"
    [mobileTitle]="processTitle()"
    icon="fas fa-project-diagram"
    [showBack]="true"
    [hasOptions]="false"
    (back)="closeEditor()">
</app-page-header>

<app-status-flow-editor />
